import { render, staticRenderFns } from "./CaretLeftFill.vue?vue&type=template&id=4f584266"
import script from "./CaretLeftFill.vue?vue&type=script&lang=js"
export * from "./CaretLeftFill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports